import { render, staticRenderFns } from "./PcSingletonSnackbar.vue?vue&type=template&id=146390fe&scoped=true"
import script from "./PcSingletonSnackbar.vue?vue&type=script&lang=js"
export * from "./PcSingletonSnackbar.vue?vue&type=script&lang=js"
import style0 from "./PcSingletonSnackbar.vue?vue&type=style&index=0&id=146390fe&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "146390fe",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VSnackbar } from 'vuetify/lib/components/VSnackbar';
installComponents(component, {VBtn,VSnackbar})
